/* eslint-disable no-use-before-define */
import React from 'react'
import {fmt} from './twd'

export const Paging = ({dataName='twd-paging', page, total, setPage, size=10}={}) => {

    return <div className="pagination-with-label text-bold">
    <ul className="pagination">
    {(() => {
        if (total===0) return null

        let ps = pages({page, total, size})

        let maxPage = ps[ps.length-1]
        let arr = []

        if (page!==1) arr.push(
            <li key={0} className="previous">
            <button
                className='btn-link'
                aria-label="previous"
                data-name={dataName + '-left'}
                style={{cursor:'pointer'}}
                onClick={() => setPage(page-1)}>
                <i className="material-icons" aria-hidden="true">chevron_left</i>
            </button>
            </li>,
        )

        for (let i=0, n=ps.length; i<n; i++) {
            let p = ps[i]
            let c = p===page
            arr.push(<li key={arr.length+1}
                    className={c ? 'active' : ''}>
                <button
                    className='btn-link'
                    aria-label={`page ${i+1}`}
                    data-name={dataName + '-page'}
                    style={c ? {} : {cursor:'pointer'}}
                    disabled={c}
                    onClick={() => setPage(p)}>

                {i === n-2 && ps[i]+1!==ps[i+1] ? '...' : fmt.count(p)}

                </button>
            </li>)
        }

        if (page!==maxPage) arr.push(
            <li key={arr.length+1} className="next">
            <button
                className='btn-link'
                aria-label="next"
                data-name={dataName + '-right'}
                style={{cursor:'pointer'}} onClick={() => setPage(page+1)}>
                <i className="material-icons" aria-hidden="true">chevron_right</i>
            </button>
            </li>
        )

        return arr
    })()}
    </ul>
    </div>
}


const pages = ({page=0, total=0, size=10}={}) => {
    let nPages = Math.ceil(total / size)
    var pages = []
    if (nPages===0) return pages

    if (page < 5) {
        pages = [...Array(6).keys()].map(i => i + 1)
    }
    else if (page + 5 >= nPages) {
        pages = [...Array(6).keys()].map(i => nPages - 6 + i)
    }
    else {
        pages = [...Array(6).keys()].map(i => page - 3 + i)
    }
    pages = pages.filter(a => a<nPages)
    pages.push(nPages)

    return pages
}


// WEBPACK FOOTER //
// ./src/twd/paging.js